/**
 * NotificationBanner - Banner mời cài đặt thông báo
 * Hiển thị trong News Hub, có thể đóng và nhớ trạng thái
 */
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { HiOutlineX, HiOutlineBell, HiOutlineCog } from 'react-icons/hi'
import { FaTelegramPlane } from 'react-icons/fa'

const TELEGRAM_CHANNEL_URL = 'https://t.me/+FzvKdNbv_rZiMjI1'
const STORAGE_KEY = 'notification_banner_dismissed'
const DISMISS_DURATION = 7 * 24 * 60 * 60 * 1000 // 7 ngày

export default function TelegramBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    // Kiểm tra đã dismiss chưa
    const dismissedAt = localStorage.getItem(STORAGE_KEY)
    if (dismissedAt) {
      const elapsed = Date.now() - parseInt(dismissedAt, 10)
      if (elapsed < DISMISS_DURATION) {
        return // Vẫn còn trong thời gian dismiss
      }
    }
    setVisible(true)
  }, [])

  const handleDismiss = () => {
    setVisible(false)
    localStorage.setItem(STORAGE_KEY, Date.now().toString())
  }

  if (!visible) return null

  return (
    <div className="mb-4 relative overflow-hidden rounded-xl bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-lg">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute -right-4 -top-4 w-32 h-32 rounded-full bg-white" />
        <div className="absolute -left-8 -bottom-8 w-40 h-40 rounded-full bg-white" />
      </div>

      <div className="relative px-4 py-4 sm:px-6 sm:py-5">
        <div className="flex items-center justify-between gap-4">
          {/* Content */}
          <div className="flex items-center gap-4 flex-1 min-w-0">
            {/* Icon */}
            <div className="hidden sm:flex items-center justify-center w-12 h-12 rounded-full bg-white/20 flex-shrink-0">
              <HiOutlineBell className="w-6 h-6" />
            </div>

            {/* Text */}
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <HiOutlineBell className="w-5 h-5 sm:hidden" />
                <h3 className="font-semibold text-base sm:text-lg">
                  Nhận thông báo tin tức BĐS mới
                </h3>
              </div>
              <p className="text-sm text-white/90 hidden sm:block">
                Chọn cách nhận: Telegram Bot hoặc thông báo trình duyệt
              </p>
            </div>
          </div>

          {/* Actions */}
          <div className="flex items-center gap-2 flex-shrink-0">
            {/* Quick join Telegram */}
            <a
              href={TELEGRAM_CHANNEL_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="hidden sm:inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white/20 text-white text-sm hover:bg-white/30 transition-colors"
            >
              <FaTelegramPlane className="w-4 h-4" />
              <span>Telegram</span>
            </a>

            {/* Cài đặt */}
            <Link
              to="/settings"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-white text-indigo-600 font-medium text-sm hover:bg-indigo-50 transition-colors shadow-sm"
            >
              <HiOutlineCog className="w-4 h-4" />
              <span>Cài đặt</span>
            </Link>

            <button
              onClick={handleDismiss}
              className="p-1.5 rounded-lg hover:bg-white/20 transition-colors"
              title="Đóng"
            >
              <HiOutlineX className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
